import React from "react";
import styled from "@emotion/styled/macro";

import rotateIcon from "../../res/img_hint_rotate.svg";

const RotateHint = styled("i")`
  width: 85.33333%;
  background: url(${rotateIcon}) no-repeat center center;
  background-size: contain;
  display: block;
  position: absolute;
  bottom: 4%;
  left: 50%;
  transform: translateX(-50%);

  &:after {
    content: "";
    display: block;
    padding-bottom: 31.5625%;
  }
`;

export default function RotateBobbleheadHint() {
  return <RotateHint />;
}
